import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAdvertisementhome } from "../../features/advertisementhomeSlice";
import { useDispatch, useSelector } from "react-redux";

const Addsec = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { advertisementhomedata, status, error } = useSelector(
    (state) => state.advertisementhome
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAdvertisementhome());
    }
  }, [dispatch, status]);

  const Categorypage = (item) => {
    if (item.select_type == 1) {
      if (item.category_id) {
        navigate(`/category/${item.category_id}`);
      } else if (item.subcategory_id) {
        navigate(`/subcategory/${item.subcategory_id}`);
      } else if (item.subchildcategory_id) {
        navigate(`/subchildcategory/${item.subchildcategory_id}`);
      }
    } else if (item.select_type == 2) {
      if (item.product_id) {
        navigate(`/product-details/${item.product_id}`);
      }
    } else if (item.select_type == 3) {
      if (item.classification_id) {
        navigate(`/classification_list/${item.classification_id}`);
      }
    }
  };

  return (
    <div
      className="addsec-bg"
      onClick={() => Categorypage(advertisementhomedata)}
      style={{
        backgroundImage: `url(${advertisementhomedata.advertisement_img})`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6"></div>
        </div>
      </div>
    </div>
  );
};

export default Addsec;
